import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';

const OrthopedicPhysiotherapy = () => {
  const serviceData = {
    title: "Orthopedic Physiotherapy",
    image: "/ortho.png",
    description: "Our orthopedic physiotherapy service focuses on treating musculoskeletal conditions, including joint problems, post-surgical rehabilitation, and chronic pain management.",
    benefits: [
      "Joint and muscle injuries treatment",
      "Post-surgical rehabilitation",
      "Arthritis management",
      "Spine conditions treatment",
      "Sports injuries recovery",
      "Chronic pain management"
    ],
    approach: [
      "Comprehensive musculoskeletal assessment",
      "Evidence-based treatment protocols",
      "Manual therapy techniques",
      "Exercise prescription",
      "Pain management strategies",
      "Functional rehabilitation"
    ]
  };

  return <ServiceLayout {...serviceData} />;
};

export default OrthopedicPhysiotherapy; 